import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, ArrowRight } from 'lucide-react';

const PagamentoCompletatoPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const ordineId = searchParams.get('ordine');

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="h-8 w-8 text-green-600" />
          </div>
          
          <h1 
            className="text-2xl font-semibold text-slate-900 mb-2"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Pagamento Completato!
          </h1>
          
          <p className="text-slate-600 mb-6">
            Il tuo pagamento è stato elaborato con successo. Il QR Code del memorial verrà attivato a breve.
          </p>
          
          {ordineId && (
            <p className="text-sm text-slate-500 mb-6">
              Ordine: <span className="font-mono">{ordineId}</span>
            </p>
          )}
          
          <div className="space-y-3">
            <Button 
              onClick={() => navigate('/elogi')}
              className="w-full bg-slate-900 hover:bg-slate-800"
            >
              Vai ai tuoi Elogi
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/dashboard')}
              className="w-full"
            >
              Torna alla Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PagamentoCompletatoPage;
